/***************/
/*** General ***/
/***************/
export const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8008";
export const SKIP_LICENSING_CHECK =
  import.meta.env.VITE_SKIP_LICENSING_CHECK === "check-with-server"
    ? "check-with-server"
    : import.meta.env.VITE_SKIP_LICENSING_CHECK === "true";
export const SKIP_MAINTENANCE_CHECK = import.meta.env.VITE_SKIP_MAINTENANCE_CHECK === "true";

/******************/
/*** Onboarding ***/
/******************/
export const SKIP_ONBOARDING_STATUS_CHECK =
  import.meta.env.VITE_SKIP_ONBOARDING_STATUS_CHECK === "true";

/**************************/
/*** Documentation URLs ***/
/**************************/
export const SCHEDULES_DOCS_URL = "https://www.youtube.com/watch?v=baH59JpfMSc";

/***************/
/*** Theming ***/
/***************/
export const ENABLE_THEMING = import.meta.env.VITE_ENABLE_THEMING === "true";

/******************/
/*** Chat ***/
/******************/
export const FORCE_ENABLE_CHAT = import.meta.env.VITE_FORCE_ENABLE_CHAT === "true";
export const CHAT_PATH = "/home";
export const DASHBOARDS_PATH = "/dashboards";
export const DASHBOARDS_ROUTE_ID = "thoughtspot-dashboards";
export const AI_DASHBOARDS_PATH = "/ai-dashboards";
export const AI_SCHEDULES_PATH = "/ai-schedules";

// This should be added to the state whenever a route change which should not trigger an embedding navigation happens
export const ROUTE_STATE_EMBED_SHOULD_IGNORE_ROUTE_CHANGE = "embed_should_ignore_route_change";
